var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 22,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M.5 10.7c0-1.9.01-2.7.34-3.39.34-.7.96-1.22 2.47-2.46l1.43-1.18c1.34-1.1 2.31-1.9 3.14-2.43A3.87 3.87 0 0 1 10 .5c.66 0 1.3.22 2.12.74.83.53 1.8 1.33 3.14 2.43l1.43 1.18c1.5 1.24 2.13 1.77 2.47 2.46.33.7.34 1.49.34 3.4v5.8c0 1.31 0 2.24-.1 2.95-.1.68-.28 1.08-.58 1.38-.31.3-.74.47-1.46.56-.74.1-1.71.1-3.07.1H5.7c-1.36 0-2.33 0-3.07-.1-.72-.09-1.15-.27-1.46-.56-.3-.3-.48-.7-.58-1.38-.1-.7-.1-1.64-.1-2.94V10.7Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  d: "M13 21v-7a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export default ForwardRef;